import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import './style.css';
import './workspace.css';
import './card-studio.css';
import './public-layout.css';
import './resources.css';
import './app-store-links.css';
import './editor-polish.css';
import './settings.css';
let resumeCreation = false;
try {
  const started = Number(sessionStorage.getItem('relay.creation.auth'));
  resumeCreation = ['/app', '/login'].includes(location.pathname) && started > 0 && Date.now() - started < 600_000 && Boolean(sessionStorage.getItem('relay.creation.v1'));
} catch { /* Continue normally when browser storage is unavailable. */ }
if (resumeCreation) {
  const params = new URLSearchParams(location.search); params.set('creation', 'resume');
  location.replace('/?' + params.toString());
} else createRoot(document.getElementById('root')!).render(<React.StrictMode><ErrorBoundary><App/></ErrorBoundary></React.StrictMode>);
